import { useState, useEffect, useCallback } from 'react';
import { usePostMessage, useReceiveMessage } from '../../context/messageContext';
import { useNewStimulus } from './useNewStimulus';

const getDelayBetweenStimuli = (targetDuration) => {
  const randomDelay = Math.floor(Math.random() * 1500);
  const minDelay = targetDuration < 1000 ? 300 : 800;

  if (randomDelay < minDelay) {
    return getDelayBetweenStimuli();
  } else return randomDelay;
};

export const useStimulusCycle = () => {
  const [showStimulus, setShowStimulus] = useState(false);
  const [targetDuration, setTargetDuration] = useState(0);
  const postMessage = usePostMessage();
  const receivedMessage = useReceiveMessage();
  const getNextStimulus = useNewStimulus();

  const getDot = useCallback(
    ({ dotsForDisplay, seenDots, getSeenDot }) => {
      if (!dotsForDisplay.length) return postMessage({ type: 'useVisualFieldReducer', action: 'setTestEnded' });
      const { newDot } = getNextStimulus({ dotsForDisplay, seenDots, getSeenDot });
      return postMessage({ type: 'useVisualFieldReducer', action: 'setActiveDot', payload: newDot });
    },
    [getNextStimulus, postMessage],
  );

  const destroyDot = useCallback(() => {
    const delayBetweenStimuli = getDelayBetweenStimuli(targetDuration);
    postMessage({ type: 'endStimulusCycle' });
    return setTimeout(() => postMessage({ type: 'beginStimulusCycle' }), delayBetweenStimuli);
  }, [postMessage, targetDuration]);

  const hideDot = useCallback(() => {
    const responseWindow = Math.max(1000 - targetDuration, 0);
    setShowStimulus(false);
    setTimeout(() => destroyDot(), responseWindow);
  }, [targetDuration, destroyDot]);

  useEffect(() => {
    if (showStimulus) {
      const dotDisplayTimer = setTimeout(() => hideDot(), targetDuration);
      return () => clearTimeout(dotDisplayTimer);
    }
  }, [showStimulus, targetDuration, hideDot]);

  useEffect(() => {
    if (receivedMessage.type === 'calibrationDataFromOptician') setTargetDuration(receivedMessage.content.targetDuration);
  }, [receivedMessage]);

  return { showStimulus, setShowStimulus, getDot };
};
